import React, { useEffect, useState } from "react";
import { OmnijusSelectField } from "../fields/omnijus-select-field";
import { Loading } from "@omnijus/common";
import { MovimentacaoAssistidaService } from "../../../services/movimentacao-assistida/movimentacao-assistida-service";

interface OmnijusFiltroStatusDocumentoRotuloProps {
    hideLabel?: boolean;
    name?: string;
    label?: string;
    isDisabled?: boolean;
    isMulti?: boolean;
}

export const OmnijusFiltroStatusDocumentoRotulo = (props: OmnijusFiltroStatusDocumentoRotuloProps) => {
    const [promiseOpcoes, setPromiseOpcoes] = useState<Promise<{ id: number; value: string }[] | undefined>>();

    useEffect(() => {
        setPromiseOpcoes(MovimentacaoAssistidaService.listarStatusDocumentoRotulo());
    }, []);

    return (
        <Loading promise={promiseOpcoes}>
            {(opcoes) => (
                <OmnijusSelectField
                    isMulti={props.isMulti}
                    name={props.name || "idStatusDocumentoRotulo"}
                    label={props.label}
                    options={opcoes
                        ?.map((o) => ({
                            value: o.id.toString(),
                            label: o.value.toString(),
                        }))
                        .sort((a, b) => (a.label < b.label ? -1 : a.label > b.label ? 1 : 0))}
                />
            )}
        </Loading>
    );
};
